import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';

@Injectable({
  providedIn: 'root'
})

export class budgetformService {
    constructor(private http: HttpClient,public errorService: ErrorService,private handler: HttpBackend) { }   
      GetAllClientsDropDownbyAgency(): Observable<any> {
        let url = "api/EmployeePayrate/GetcliDD"
        return this.http.get<any>(url , { observe: 'response' }).pipe(
          map(data => data.body),
          catchError(this.errorService.handleError)
        );
      }

      GetAllClientDetails(params:URLSearchParams): Observable<any> {
        let url = "api/Budget/GetClientDetails"
        return this.http.get<any>(url , { observe: 'response' }).pipe(
          map(data => data.body),
          catchError(this.errorService.handleError)
        );
      }
      
      getAllBudgetsForClient(params:URLSearchParams): Observable<any> {
        let url = "api/Budget/getAllBudgetsForClient?"
        return this.http.get<any>(url+params , { observe: 'response' }).pipe(
          map(data => data.body),
          catchError(this.errorService.handleError)
        );
      }

      getAllBudgetsForOnboardClient(): Observable<any> {
        let url = "api/Client_Budget/getAllBudgetsDetailsForClient?"
        return this.http.get<any>(url , { observe: 'response' }).pipe(
          map(data => data.body),
          catchError(this.errorService.handleError)
        );
      }

      getpowerbiToken(): Observable<any> {
        let url = "api/PowerBI/GetAccessToken?"
        return this.http.get<any>(url, { observe: 'response' }).pipe(
          map(data => data.body),
          catchError(this.errorService.handleError)
        );
      }
      
      getpowerbiTokenForOnboard(): Observable<any> {
        let url = "api/Client_PowerBI/GetPortalAccessToken?"
        return this.http.get<any>(url, { observe: 'response' }).pipe(
          map(data => data.body),
          catchError(this.errorService.handleError)
        );
      }

}